import { IConfiguration, IChangeStyle } from "@/store/modules/utils/util.t"

export interface ICustomStylingClass {
  label: string;
  value: boolean;
}

export type ICustomsElementTypes =
 | 'p'
 | 'span'
 | 'a'
 | 'h1'
 | 'h2'
 | 'h3'
 | 'h4'
 | 'h5'
 | 'h6';

 export type ICustomsContainerTypes =
 | 'div'
 | 'ul'
 | 'ol'
 | 'section'
 | 'li';

 export type SwatchType = {
  id: string
  check_icon_color: 'black' | 'white'
  factory_name: string
  stitch_color: string
  material_type: string
  status: number
  updated_timestamp: string
  color: string
  exclusive: boolean
  display_name: any
  geometry_updates: string[]
  material_options: any
  swatch_factory_details: any
  "cq:tags": string
  material_group: string[]
 }

 export type TabType = {
  name: string
  display_name: string
  icon?: string
  title_only: boolean
  sub_groups: string[]
  feature_tab: boolean
}

export type subGroupType = {
  name: string
  display_name: string
  order: number
  palette_id: string
  swatches?: SwatchType[]
}

export enum ICustomProductTypes {
  FOOTWEAR = 'footwear',
  APPAREL = 'apparel',
  BACKPACK = 'backpack'
}

export interface IFavoriteModalProps {
  favoriteSaved?: boolean;
  tmallEnabled?: boolean;
}

export interface IBuyPanelProductProps {
  size: string;
  quantity: number;
}

export interface IRepositionWatningModalProps {
  newUGCSize?: string;
  prevUGCSize?: string;
  deletePreviousRecipe?: boolean;
  sizeIdentifierValue?: string;
  storeMultipleUGCsizes?: boolean;
}

export type IModelImage = {
  string?: string
}

export type IModelPrice= {
  string?: string
}
